'use strict';

var $ = (typeof window !== "undefined" ? window.jQuery : typeof global !== "undefined" ? global.jQuery : null);

var bodyStateDetection = require('body-state-detection');

var dom = {},

	setupDom = function(){

		dom.document = $(document);
		dom.promoVideo = $("[data-video]");
		dom.footerVideo = $(".footer-video-info");

	},

	addEventHandlers = function(){

		dom.promoVideo.click(function(e){

			var viewportSize = bodyStateDetection.getState();

			if(viewportSize === "small" || viewportSize === "medium") {

				window.open("/corporate/promo_video.cfm?id=" + $(this).attr("data-video"));

			}

			else {

				modal.open("/corporate/promo_video.cfm?id=" + $(this).attr("data-video"), {
					height: 540,
					width: 920,
					closeBtn: true,
					modalClass: 'promo-video',
					modal: false
				});

			}

			e.preventDefault();

		});

		dom.document.on("jqm_modal_closed", function(){

			$("#modal").removeClass("promo-video");

		});

		dom.footerVideo.on("click", function(e){

			e.preventDefault();

			window.location = $(this).attr("data-story-url");

		});

	},

	init = function(){

		setupDom();

		addEventHandlers();

	};

init();
